export default "<p>authcallback works!</p>\r\n"